// eslint-disable @typescript-eslint/no-magic-numbers
import { StepType, TestType, TrainingAnswers, TrainingBlock } from './types';

export const nannyBlocks: TrainingBlock[] = [
  {
    id: 1,
    title: '1 Блок. Образ няни',
    steps: [
      {
        stepType: StepType.Video,
        videoId: 'CMn-ybl_yWs',
        url: 'https://cdn.youhelp.ru/training/lesson-1.mp4',
      },
      {
        stepType: StepType.Test,
        question: 'Что из нижеперечисленного НЕДОПУСТИМО в образе няни?',
        id: 1,
        type: TestType.Variants,
        variants: [
          {
            title: 'Яркий макияж',
            value: 1,
          },
          {
            title: 'Собранные волосы',
            value: 2,
          },
          {
            title: 'Ожерелье из жемчуга',
            value: 3,
          },
          {
            title: 'Длинные ногти нейтральных оттенков',
            value: 4,
          },
        ],
      },
      {
        stepType: StepType.Test,
        question: 'Какими качествами должна обладать няня?',
        id: 2,
        type: TestType.Variants,
        variants: [
          {
            title: 'ответственность',
            value: 1,
          },
          {
            title: 'доброта',
            value: 2,
          },
          {
            title: 'тактичность',
            value: 3,
          },
          {
            title: 'пунктуальность',
            value: 4,
          },
        ],
      },
      {
        stepType: StepType.Test,
        question: 'Какие темы не должны обсуждаться с родителями и ребенком во время заказа?',
        id: 3,
        type: TestType.Variants,
        variants: [
          {
            title: 'Религия',
            value: 1,
          },
          {
            title: 'Погода',
            value: 2,
          },
          {
            title: 'Личная жизнь',
            value: 3,
          },
          {
            title: 'Политика',
            value: 4,
          },
        ],
      },
      {
        stepType: StepType.Test,
        question: 'Что такое пунктуальность?',
        id: 4,
        type: TestType.Text,
      },
      {
        stepType: StepType.Test,
        question: 'Обязательно ли брать сменную одежду на заказ?',
        id: 5,
        type: TestType.SingleVariant,
        variants: [
          { title: 'да', value: 1 },
          { title: 'нет', value: 2 },
        ],
      },
    ],
  },
  {
    id: 2,
    title: '2 Блок. Как проходит заказ',
    steps: [
      {
        stepType: StepType.Video,
        videoId: 'eLc72wlBFUE',
        url: 'https://cdn.youhelp.ru/training/lesson-2.mp4',
      },
      {
        id: 1,
        stepType: StepType.Test,
        type: TestType.Variants,
        question: 'Какие вопросы можно задавать родителю на заказе?',
        variants: [
          {
            title: 'Где я могу помыть руки и переодеться?',
            value: 1,
          },
          {
            title: 'Есть ли у ребенка аллергия?',
            value: 2,
          },
          {
            title: 'Как я могу с Вами связаться?',
            value: 3,
          },
        ],
      },
      {
        id: 2,
        stepType: StepType.Test,
        type: TestType.Text,
        question: 'Почему нельзя оценивать ребенка?',
      },
      {
        id: 3,
        stepType: StepType.Test,
        type: TestType.SingleVariant,
        question: 'Как няня может предложить родителю расплатиться?',
        variants: [
          {
            title: 'Только наличными',
            value: 1,
          },
          {
            title: 'Только переводом на карту',
            value: 2,
          },
          {
            title: 'Наличными или переводом на карту',
            value: 3,
          },
        ],
      },
      {
        id: 4,
        stepType: StepType.Test,
        type: TestType.SingleVariant,
        question: 'Можно ли играть с ребенком на заказе в прятки?',
        variants: [
          { title: 'Можно', value: 1 },
          { title: 'Нельзя', value: 2 },
          { title: 'По желанию ребенка', value: 3 },
        ],
      },
      {
        id: 5,
        stepType: StepType.Test,
        type: TestType.Variants,
        question: 'Какие важные вопросы нужно задать родителю перед уходом о ребенке, если он очень спешит?',
        variants: [
          { title: 'Есть ли аллергия у ребенка?', value: 1 },
          { title: 'Как я могу с Вами связаться при необходимости?', value: 2 },
          { title: 'Покажите, как работает микроволновка?', value: 4 },
          { title: 'Где лежат игрушки?', value: 6 },
        ],
      },
      {
        id: 6,
        stepType: StepType.Test,
        type: TestType.SingleVariant,
        question: 'Сколько номеров телефона заказчика знает няня?',
        variants: [
          { title: 'Один', value: 1 },
          { title: 'Два', value: 2 },
          { title: 'Ни одного', value: 3 },
        ],
      },
    ],
  },
  {
    id: 3,
    title: '3 Блок. Все о ребенке',
    steps: [
      {
        stepType: StepType.Video,
        videoId: '60IFp739Mik',
        url: 'https://cdn.youhelp.ru/training/lesson-3.mp4',
      },
      {
        id: 1,
        stepType: StepType.Test,
        type: TestType.Text,
        question: 'Почему нельзя дружить с ребенком?',
        questionDescription: 'Напишите в свободной форме',
      },
      {
        id: 2,
        stepType: StepType.Test,
        type: TestType.SingleVariant,
        question: 'Можно ли смотреть мультфильмы с ребенком на заказе?',
        questionDescription: 'Выберите один ответ',
        variants: [
          { title: 'Да', value: 1 },
          { title: 'Нет', value: 2 },
          { title: 'Можно с разрешения родителя', value: 3 },
        ],
      },
      {
        id: 3,
        stepType: StepType.Test,
        type: TestType.Text,
        question: 'Как уходить от неудобных вопросов, заданных ребенком няне?',
      },
      {
        id: 4,
        stepType: StepType.Test,
        type: TestType.Variants,
        question: 'Из каких элементов состоит сюжетно-ролевая игра?',
        variants: [
          { title: 'Метафора', value: 1 },
          { title: 'История', value: 2 },
          { title: 'Персонажи', value: 3 },
          { title: 'Сюжет', value: 4 },
        ],
      },
      {
        id: 5,
        stepType: StepType.Test,
        type: TestType.Text,
        question: 'Что такое истерика простыми словами и как ее можно остановить?',
      },
    ],
  },
];

export const nannyAnswers: TrainingAnswers = {
  1: { 1: [1, 3, 4], 2: [1, 2, 3, 4], 3: [1, 3, 4], 5: 1 },
  2: { 1: [1, 2, 3], 3: 3, 4: 2, 5: [1, 2], 6: 2 },
  3: { 2: 3, 4: [1, 3, 4] },
};
